:host {
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	row-gap: 1rem;
	column-gap: 0.5rem;
	width: fit-content;
}
